import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 页面主接口
export const getHomePage = createAsyncThunk(
  'getHomePage/live/misc/new_user_act_center',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/misc/new_user_act_center', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

export enum AwardStatusEnum {
  success = 1,
  undone = 2,
  replay = 3,
}
// 奖励领取接口
export const getAward = createAsyncThunk(
  '/live/misc/new_user_act_job_award',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/misc/new_user_act_job_award', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

export enum PageTypeEnum {
  全球 = 0,
  附近,
}

// 【排行榜接口】http://wiki.xunlei.cn/pages/viewpage.action?pageId=135994504
export const getRank = createAsyncThunk(
  'live/misc/new_user_act_rank',
  async (p: {type: PageTypeEnum} = {type: PageTypeEnum.全球}, store: any) => {
    const resp = await http.post('/live/misc/new_user_act_rank', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// 【获奖记录】 http://wiki.xunlei.cn/pages/viewpage.action?pageId=135994501
export const getPrizeRecord = createAsyncThunk(
  'live/misc/new_user_act_prize_record',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/misc/new_user_act_prize_record', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

export enum JobTypeEnum {
  room = 1,
  recharge = 2,
}

export enum TaskEnum {
  undo = 0,
  done = 1,
  received = 2,
}

export enum UserEnum {
  unpart = 0, // 无资格参与
  normal = 1, // 活动前3天可完成任务
  four = 2, // 活动第四天，仅查看和领奖励
  end = 3, // 活动结束
  over = 4, // 超出人数上限
}

export interface StageItem {
  stage_no: number
  desc: string
  target: number
  progress: number
  status: TaskEnum
  award_point: number
}

const initialState: {
  homePage?: {
    draw_time?: number
    notices?: {
      avatar: string
      name: string
      prize_name: string
      price: number
    }[]
    lucky_point?: number
    over_proportion?: number
    avatar?: string
    prize_list?: {
      name: string
      icon: string
    }[]
    jobs?: {
      type: JobTypeEnum
      jump_url: string
      stages: StageItem[]
    }[]
    last_prize?: {
      name: string
      icon: string
    }
    daily_first?: boolean
    coin_pool?: number
    pool_price?: number
    participants?: number
    remaining_days?: number
    game_url?: string
    status?: UserEnum
    exchange_rate?: number
  }
  rankRes?: {
    rank: {
      rank_no: number
      name: string
      avatar: string
      lucky_point: number
      coins: number
      mid: number
    }[]
    offset: number
    more: boolean
  }
  prizeRecord?: {
    time: string
    lucky_point: number // 幸运值
    prize_name: string
    prize_icon: string
    status: 0 | 1 // 0 for unredeemed, 1 for redeemed
  }[]
} = {
  // homePage: {
  //   draw_time: 1000,
  //   notices: [
  //     {
  //       avatar:
  //         'http://me-media-gateway.srv.test.ixiaochuan.cn/account/view/id/21078619/sz/src',
  //       name: 'bigfolwer ',
  //       prize_name: 'bigfolwer ',
  //       price: 1000,
  //     },
  //     {
  //       avatar:
  //         'http://me-media-gateway.srv.test.ixiaochuan.cn/account/view/id/21078619/sz/src',
  //       name: 'bigfolwer ',
  //       prize_name: 'bigfolwer ',
  //       price: 1000,
  //     },
  //     {
  //       avatar:
  //         'http://me-media-gateway.srv.test.ixiaochuan.cn/account/view/id/21078619/sz/src',
  //       name: 'bigfolwer ',
  //       prize_name: 'bigfolwer ',
  //       price: 1000,
  //     },
  //   ],
  //   lucky_point: 100,
  //   over_proportion: 1000,
  //   avatar:
  //     'http://me-media-gateway.srv.test.ixiaochuan.cn/account/view/id/21078619/sz/src',
  //   prize_list: [
  //     {
  //       name: '1',
  //       icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //     },
  //     {
  //       name: '2',
  //       icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //     },
  //     {
  //       name: '3',
  //       icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //     },
  //     {
  //       name: '4',
  //       icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //     },
  //     {
  //       name: '5',
  //       icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //     },
  //     {
  //       name: '6',
  //       icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //     },
  //     {
  //       name: '7',
  //       icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //     },
  //     {
  //       name: '8',
  //       icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //     },
  //   ],
  //   jobs: [
  //     {
  //       type: JobTypeEnum.room,
  //       jump_url: '',
  //       stages: [
  //         {
  //           stage_no: 1,
  //           desc: 'string',
  //           target: 1,
  //           progress: 1,
  //           status: TaskEnum.done,
  //           award_point: 1,
  //         },
  //         {
  //           stage_no: 2,
  //           desc: 'string',
  //           target: 10,
  //           progress: 1,
  //           status: TaskEnum.undo,
  //           award_point: 100,
  //         },
  //       ],
  //     },
  //     {
  //       type: JobTypeEnum.recharge,
  //       jump_url: '',
  //       stages: [
  //         {
  //           stage_no: 1,
  //           desc: 'string',
  //           target: 1,
  //           progress: 1,
  //           status: TaskEnum.undo,
  //           award_point: 1,
  //         },
  //       ],
  //     },
  //   ],
  //   daily_first: false,
  //   coin_pool: 10000,
  //   pool_price: 1000.0,
  //   participants: 10,
  //   remaining_days: 3,
  //   game_url: 'dqsdas',
  //   status: UserEnum.normal,
  // },
  // homePage: {
  //   status: 0,
  // },
}

export const PowerNewUserSlice = createSlice({
  name: 'PowerNewUser',
  initialState,
  reducers: {
    setJobs: (state, action: PayloadAction<any>) => {
      Object.assign(state.homePage, {
        jobs: action.payload,
      })
    },
    updateCoins: (state, action: PayloadAction<any>) => {
      const {coin_pool, pool_price, participants} = action.payload
      Object.assign(state.homePage, {
        coin_pool,
        pool_price,
        participants,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomePage.fulfilled, (state, action) => {
      Object.assign(state, {homePage: action.payload})
    })
    builder.addCase(getRank.fulfilled, (state, action) => {
      Object.assign(state, {rankRes: action.payload})
    })
    builder.addCase(getPrizeRecord.fulfilled, (state, action) => {
      Object.assign(state, {prizeRecord: action.payload?.records || []})
    })
  },
})
export default PowerNewUserSlice.reducer
export const PowerNewUserActions = PowerNewUserSlice.actions
